import React, { Component } from 'react';
import './checkbox.scss';

export class Checkbox extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const {onChange} = this.props;
        if(onChange) onChange(event);
    }

    render() {
        const { label, labelSide, isChecked, className, name, disabled} = this.props;

        const side = labelSide || 'right';
        const renderLabel = (s) => (s === side) ? label : '';

        return (
            <div className={`checkboxLabel ${className ? className : ''}`}>
               {renderLabel('right')}
                <label className="checkboxWrapper">
                    <input type="checkbox" name={name} value={isChecked} disabled={disabled ? disabled : false} onChange={this.handleChange} checked={isChecked}/>
                    <span className="slider"></span>
                </label>
                {renderLabel('left')}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Form/Checkbox.jsx